import "intersection-observer";
import { getEffectTarget } from "@lilib/utils";
import usePersist from "./usePersist";
import useLayoutTargetEffect from "./useLayoutTargetEffect";
function useIntersectionObserver(target, listener, options) {
  var handler = usePersist(listener);
  var _ref = options || {},
    root = _ref.root,
    rootMargin = _ref.rootMargin,
    threshold = _ref.threshold;
  useLayoutTargetEffect(function () {
    var rootElement = getEffectTarget(root);
    var targetElement = getEffectTarget(target);
    if (!targetElement) {
      return;
    }
    var observer = new IntersectionObserver(handler, {
      root: rootElement,
      rootMargin: rootMargin,
      threshold: threshold
    });
    observer.observe(targetElement);
    return function () {
      observer.disconnect();
    };
  }, [rootMargin, threshold ? threshold.toString() : "0"], [root, target]);
}
export default useIntersectionObserver;